import { PageHeader, Tag, Popconfirm, message, Tooltip } from "antd";
import React, { Component } from "react";
import axios from 'axios'
import { ButtonItem, SegmentedItem, TableItemDinamico } from '../../../Components/Items'
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/es";
import { CheckCircleOutlined, CopyOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";

moment.locale("es");


class PlantillasPolizas extends Component {
    tableRef = React.createRef();
    state = {
        todasPlantillas: [],
        totalRecords: 0,
        loading: false,
        valor: 1,
    }

    consultarPlantillas(params) {
        this.setState({ loading: true })
        axios
            .post(
                "plantillasPolizas/selectTodasPlantillas",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasPlantillas: res.data.data.map(value => {
                            return { ...value, accion: { _id: value._id, estado: value.estado, manual: value.manual } }
                        }),
                        totalRecords: res.data.totalRecords || 0,
                        loading: false,
                    });
                } else {
                    this.setState({ todasPlantillas: [], loading: false });
                }
            });
    }
    agregarPlantilla() {
        this.props.history.push("/panel/agregarPlantillaPoliza");
    }
    editarPlantilla(id) {
        this.props.history.push('/panel/editarPlantillaPoliza', { id })
    }
    // Deshabilita un Doctor 
    deshabilitarPlantilla(id) {
        axios
            .post(
                "plantillasPolizas/deshabilitarPlantilla",
                { plantillaId: id, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Plantilla deshabilitada exitosamente");
                    if (this.tableRef) {
                        this.tableRef.updateExternalFilters({ valor: this.state.valor });
                    }
                } else if (res.data.success === 1) {
                    message.error("Error al deshabilitar la plantilla");
                } else {
                    message.error("Error");
                }
            });
    }

    // Habilita un doctor
    habilitarPlantilla(id) {
        axios
            .post(
                "plantillasPolizas/habilitarPlantilla",
                { plantillaId: id, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Plantilla habilitada exitosamente");
                    if (this.tableRef) {
                        this.tableRef.updateExternalFilters({ valor: this.state.valor });
                    }
                } else if (res.data.success === 1) {
                    message.error("Error al habilitar la plantilla");
                } else {
                    message.error("Error");
                }
            });
    }

    generarPoliza(id) {
        this.props.history.push("/panel/polizaManual", { plantillaId: id });
    }

    duplicarPlantilla(id) {
        this.props.history.push("/panel/agregarPlantillaPoliza", { id });
    }

    render() {
        const columns = [
            {
                title: "IED",
                dataIndex: "tipodepoliza",
                key: "tipodepoliza",
                render: (value) => {
                    let ied
                    if (value.tipoDePolizaId === 1) ied = 'Ingreso'
                    if (value.tipoDePolizaId === 2) ied = 'Egreso'
                    if (value.tipoDePolizaId === 3) ied = 'Traslado'
                    if (value.tipoDePolizaId === 4) ied = 'Nomina'
                    if (value.tipoDePolizaId === 5) ied = 'Pago'
                    if (value.tipoDePolizaId === 6) ied = 'Diario'
                    return ied
                },
                width: '10%'
            },
            {
                title: "Concepto",
                dataIndex: "concepto",
                key: "concepto",
                width: '25%',
                buscar: "concepto",
            },
            {
                title: "Fecha",
                dataIndex: "fechaRegistro",
                key: "fechaRegistro",
                sorter: true,
                render: (value) => moment(value).locale('es').format('L'),
                width: '15%',
            },
            {
                title: 'Estado',
                dataIndex: 'estado',
                key: 'estado',
                render: (value) => {
                    if (value === 2) {
                        return <Tag color='red'>Deshabilitada</Tag>
                    }
                    if (value === 1) {
                        return <Tag color='blue'>Vigente</Tag>
                    }
                },
                width: '10%'
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                align: "center",
                width: "30%",
                onCell: () => ({
                    className: "acciones-sin-hover"
                }),
                render: (value, record, index) => {
                    let buttons = [];

                    buttons.push(
                        <Tooltip title="Editar Plantilla" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                key={`editar-${index}`}
                                type="default"
                                size="small"
                                cyan
                                icon={<EditOutlined />}
                                onClick={() => this.editarPlantilla(record._id)}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    if (record.estado === 1) {
                        buttons.push(
                            <Popconfirm
                                key={`deshabilitar-${index}`}
                                title="¿Seguro que quieres deshabilitar esta plantilla?"
                                onConfirm={() => this.deshabilitarPlantilla(record._id)}
                                okText="Sí"
                                cancelText="No"
                            >
                                <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        lima
                                        icon={<CheckCircleOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    } else {
                        buttons.push(
                            <Popconfirm
                                key={`habilitar-${index}`}
                                title="¿Seguro que quieres habilitar esta plantilla?"
                                onConfirm={() => this.habilitarPlantilla(record._id)}
                                okText="Sí"
                                cancelText="No"
                            >
                                <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        rojo
                                        icon={<StopOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    }

                    buttons.push(
                        <Tooltip title="Duplicar Plantilla" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                key={`duplicar-${index}`}
                                type="default"
                                size="small"
                                azul
                                icon={<CopyOutlined />}
                                onClick={() => this.duplicarPlantilla(record._id)}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    buttons.push(
                        <Tooltip title="Generar Póliza desde esta plantilla" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                key={`generar-${index}`}
                                type="primary"
                                size="small"
                                naranja
                                onClick={() => this.generarPoliza(record._id)}
                            >
                                G
                            </ButtonItem>
                        </Tooltip>
                    );

                    return <div className="acciones-container">{buttons}</div>;
                },
            },
        ]
        return (
            <>
                <PageHeader
                    title="Plantillas Polizas"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            {window.innerWidth > 1000 &&
                                <SegmentedItem
                                    options={[{ label: 'Vigente', value: 1 }, { label: 'Deshabilitada', value: 2 }, { label: 'Todos', value: 3 }]}
                                    onChange={(value) => {
                                        if (this.tableRef) {
                                            this.tableRef.updateExternalFilters({ valor: value });
                                        }
                                        this.setState({ valor: value })
                                    }}
                                    value={this.state.valor}
                                />
                            }
                            {this.props.permisoAgregarPolizaManualmente &&
                                <ButtonItem
                                    type="primary"
                                    key="agregarPoliza"
                                    olivo
                                    onClick={this.agregarPlantilla.bind(this)}
                                     className="botonAgregar"
                                >
                                    Agregar Plantilla
                                </ButtonItem>}
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    anadirValorFiltro={this.state.valor}
                    onFetchData={this.consultarPlantillas.bind(this)}
                    size="small"
                    dataSource={this.state.todasPlantillas}
                    columns={columns}
                    pagination={false}
                    onRow={(record) => ({
                        onDoubleClick: () => this.editarPlantilla(record._id),
                    })}
                    filterStorageKey={"pllantillasPolizasFiltrosTabla" + this.props.empresaId}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoAgregarPolizaManualmente: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cea8ff30e81b54183cfbf")?.activado,
        permisoCancelarPolizaManualmente: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cea8ff30e81b54183cfbf")?.activado,
    };
};

export default connect(mapStateToProps)(PlantillasPolizas);